export const AIDENTIFIED_FIELD_COUNT = 428;
export const AIDENTIFIED_MAX_FILE_BYTES = 15 * 1024 * 1024;
export const AIDENTIFIED_FILE_EXTENSIONS = /\.(xlsx|csv)$/i;

export const AIDENTIFIED_MATCHED_BY = [
  { key: 'aidentifiedId', value: 'AidentifiedID', label: 'Aidentified ID' },
  { key: 'phone', value: 'Phone', label: 'Phone' },
  { key: 'email', value: 'Email', label: 'Email' },
];

export const AIDENTIFIED_NOT_LOADED_REASONS = [
  { key: 'NO_LEAD', label: 'No lead of this client has the phone or email' },
  {
    key: 'SEVERAL_CONTACTS',
    label: 'The phone or email belongs to several contacts of this client',
  },
  {
    key: 'DUPLICATE_CONTACT',
    label: 'An earlier row of the file matched the same contact',
  },
];

export const AIDENTIFIED_SOURCE_LABELS = {
  modeled: 'Modeled estimate',
  area_estimate: 'Area estimate',
};
